import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ManualTaxInvoiceEditPage = lazy(
  () => import("@/pages/tools.manual-tax-invoices.$id_.edit.page"),
);

export const Route = createFileRoute("/tools/manual-tax-invoices/$id_/edit")({
  component: ManualTaxInvoiceEditPage,
});
